import React from 'react';

export default function Footer({ children }) {
  return (
    <footer className="prints-builder__footer d-flex align-items-center flex-column">
      {children}
    </footer>
  );
}
